import React from 'react';
import { withTranslation } from "react-i18next";

import "./Raffle.scss";

import ComingSoon from "../assets/coming-soon.png";

const Raffle = (props) => {
  const { className, t } = props;

  return (
    <div className={`wf-raffle ${className ? className : ''}`}>
      <div className="wf-coming-soon">
        <div className="wf-image">
          <img src={ComingSoon} alt="coming soon" />
        </div>
        <div className="wf-text">{t("COMING SOON")}</div>
      </div>
    </div>
  );
}

export default withTranslation()(Raffle);